// @flow
import type { wrappedApiResponseType } from '../../apiTypes';
export const attachmentsMock = {
  getSingle: (id: number): Promise<wrappedApiResponseType<any>> => {
    console.log(`Called getSingle with id: ${id}`);
    return Promise.resolve({
      status: 200,
      statusText: 'OK',
      body: {},
    });
  },

  getMany: (
    limit: number = 100,
    offset: number = 0,
  ): Promise<wrappedApiResponseType<any>> => {
    console.log(`Called getMany with limit: ${limit}, offset: ${offset}`);
    return Promise.resolve({
      status: 200,
      statusText: 'OK',
      body: {
        results: [],
        count: 0,
        next: null,
        previous: null,
      },
    });
  },

  uploadSingle: (attachment: any) => {
    console.log(`Called uploadSingle with attachment:`, attachment);
    return Promise.resolve({
      status: 201,
      statusText: 'Created',
      body: {},
    });
  },

  update: (id: number, fields: any) => {
    console.log(`Called update with id: ${id}, fields:`, fields);
    return Promise.resolve({
      status: 200,
      statusText: 'OK',
      body: {},
    });
  },

  deleteAttachment: (id: string): Promise<any> => {
    console.log(`Called deleteAttachment with id: ${id}`);
    return Promise.resolve({
      status: 204,
      statusText: 'No Content',
    });
  },
};
